import { FunctionComponent } from "react";

import { Stack } from "@bps/fluent-ui";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import {
  useTenantDefaultUserAuth,
  useTenantNetworkAuthenticationSettings
} from "@libs/api/gateways/plt/plt-gateway.hooks";
import { Permissions } from "@libs/permissions/permissions.enum";

import { TenantGlobalNetworkRestrictionsSection } from "./TenantGlobalNetworkRestrictionsSection";
import { TenantUsersIpRangesSection } from "./TenantUsersIpRangesSection";

interface NetworkingSectionProps {
  tenantId: string;
}
export const TenantUsersNetworkingSection: FunctionComponent<NetworkingSectionProps> = ({
  tenantId
}) => {
  const { data: hasWritePermission } = usePermissionsCheckQuery(
    Permissions.PltCatalogUserAuthenticationWrite
  );

  const networkSettingsQuery = useTenantNetworkAuthenticationSettings(tenantId);
  const authSettingsQuery = useTenantDefaultUserAuth(tenantId);

  return (
    <QueryStateIndicator
      data={{
        networkSettings: networkSettingsQuery.data,
        authSettings: authSettingsQuery.data
      }}
      allowNullOrUndefined
      isLoading={networkSettingsQuery.isLoading || authSettingsQuery.isLoading}
      error={networkSettingsQuery.error ?? authSettingsQuery.error}
    >
      {({ networkSettings, authSettings }) => (
        <Stack tokens={{ childrenGap: 32 }}>
          <Stack>
            <TenantGlobalNetworkRestrictionsSection
              tenantId={tenantId}
              authSettings={authSettings}
              networkSettings={networkSettings}
            />
          </Stack>
          <Stack>
            <TenantUsersIpRangesSection
              hasWritePermission={!!hasWritePermission}
              networkSettings={networkSettings}
              tenantId={tenantId}
            />
          </Stack>
        </Stack>
      )}
    </QueryStateIndicator>
  );
};
